import React from 'react'
import defaultValue from './GatsbyImageContext.defaultValue'

const GatsbyImageContext = React.createContext(defaultValue)

export default GatsbyImageContext
